import { NgModule } from '@angular/core';
import { SearchPipe } from './search.pipe';
import { Filter2Pipe } from './filter.pipe';

import { FrenchDecimalPipe  } from './thousand-separator.pipe';
import { ToNumberPipe } from './tonumber.pipe';

@NgModule({
    declarations: [
        FrenchDecimalPipe,
        ToNumberPipe,
        SearchPipe,
        Filter2Pipe
    ],
    imports     : [],
    exports     : [
        FrenchDecimalPipe,
        ToNumberPipe,
        SearchPipe,
        Filter2Pipe
    ]
})
export class PipesModule
{
}
